import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

export declare type IconType = 'email' | 'add' | null

@Component({
  selector: 'secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss']
})

export class SecondaryButtonComponent implements OnInit {

  @Input() title!: string
  @Input() enabled = true
  @Input() withEnterKey = false
  @Input() loading: boolean = false
  @Input() iconType: IconType = null
  @Input() enableKeyboardEvent: boolean = true
  @Input() showArrow: boolean = false
  @Input() borderRadius: string = "12px";
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>()

  constructor() {
  }

  get icon(): string {
    return ''
  }

  ngOnInit(): void {

  }

  isButtonEnabled(): string {
    if (!this.enabled || this.loading) {
      return 'disabled'
    } else {
      return ''
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (this.withEnterKey) {
      if (event.key === "Enter") {
        if (this.enabled && !this.loading && this.enableKeyboardEvent) {
          this.onClick.emit()
        }
      }
    }
  }

}
